import { useEffect } from 'react'
import { useGetAllTeamsQuery } from '../redux/team.endpoints'
import { useGetAllTribesQuery } from '../redux/tribe.endpoints'
import {
  useLazyGetAllExperienceLevelQuery,
  useLazyGetAllTechnologiesQuery,
} from '../redux/techstack.endpoints'

export const useMemberFormData = (companyId: number) => {
  const { data: tribes = [], isSuccess: tribesSuccess } = useGetAllTribesQuery({
    companyId,
    pageSize: 0,
    pageNumber: 0,
    sortBy: 'id',
    searchQuery: '',
    sortType: 'DESC',
  })
  const { data: teams = [], isSuccess: teamsSuccess } =
    useGetAllTeamsQuery(companyId)
  const [getAllExperienceLevel, { data: experienceLevel = [] }] =
    useLazyGetAllExperienceLevelQuery()
  const [getAllTechnologies, { data: technologyList = [] }] =
    useLazyGetAllTechnologiesQuery()

  useEffect(() => {
    const query = {
      pageSize: 0,
      pageNumber: 0,
      sortBy: 'id',
      sortType: 'DESC' as const,
      search: '',
    }

    getAllExperienceLevel(query)
    getAllTechnologies(query)
  }, [getAllExperienceLevel, getAllTechnologies])

  return {
    tribes,
    teams,
    technologyList,
    experienceLevel,
    isReady: tribesSuccess && teamsSuccess,
  }
}
